import React, {useEffect, useState} from 'react';
import {
  Linking,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import {useDispatch} from 'react-redux';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import FastImage from '../../../common/FastImage';
import {globalImport} from '../../../common/globalImports';
import {usePolling} from '../../../common/usePolling';
import {Button} from '../../../components/core/Button';
import {navigationReset} from '../../../navigation/rootNavigation';
import {wp_chat, wp_logo} from '../../../utils/images';
import {Network} from '../../../utils/network';
import {OTPLESS_VERIFY} from '../redux/login.action';

const WPStatus = ({navigation, sid}) => {
  const dispatch = useDispatch();
  const [isExpired, setIsExpired] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const isWeb = globalImport.isWeb;
  usePolling(
    () => {
      livePollingRequest();
    },
    5000,
    sid || !isWeb ? false : isExpired ? false : true,
  );

  const onTryAgain = () => {
    navigation.pop();
  };

  const getSessionId = async () => {
    const wpSessionResponse = await Network.getWPSession();
    setSessionId(wpSessionResponse?.data?.sid);
    if (globalImport.isWeb) {
      window.open(wpSessionResponse?.data?.link);
    } else {
      Linking.openURL(wpSessionResponse?.data?.link);
    }
  };

  useEffect(() => {
    if (!sid) {
      getSessionId();
    }
  }, []);

  const approveLoginFunc = async () => {
    let order_id;
    if (globalImport.isWeb) {
      var query = window.location.search.substring(1);

      order_id = query.split('=')[1];
    } else {
      order_id = true;
    }

    if (order_id) {
      const approveLoginResponse = await Network.approveWPLogin({sid: sid});
      if (approveLoginResponse?.data?.error) {
        setIsExpired(true);
      }
      if (approveLoginResponse) {
        dispatch(OTPLESS_VERIFY(approveLoginResponse));
      }
    }
  };

  useEffect(() => {
    // if (globalImport.isWeb) {
    if (sid) {
      approveLoginFunc();
    }
    // }
  }, []);

  const livePollingRequest = async () => {
    const wpStatusResponse = await Network.getWPStatus(sessionId);
    if (wpStatusResponse?.data?.status === 'APPROVED') {
      setTimeout(() => {
        navigationReset();
        window.location.reload();
      }, 1000);

      //dispatch(OTPLESS_VERIFY(wpStatusResponse?.data));
    } else if (wpStatusResponse?.data?.status === 'EXPIRED') {
      setIsExpired(true);
    }
  };
  return (
    <View style={{alignItems: 'center', marginTop: 10, flex: 1}}>
      {!isExpired ? (
        <View style={{alignItems: 'center'}}>
          <FastImage
            style={{width: Width.width - 40, height: 200}}
            source={wp_chat()}
          />
          <FastImage
            style={{width: 70, height: 70, marginTop: 30}}
            source={wp_logo()}
          />
          <View style={{paddingHorizontal: 30, alignItems: 'center'}}>
            <Text style={styles.wpTitle}>Opening Whatsapp</Text>
            <Text style={styles.wpSubTitle}>
              Simply send Whatsapp mesaage on your phone to login to TradeX{' '}
            </Text>
          </View>
        </View>
      ) : (
        <View style={{justifyContent: 'center', flex: 1, marginTop: 30}}>
          <Text style={styles.wpTitle}>Session Timed Out</Text>
          <Button
            variant="primary"
            onPress={onTryAgain}
            style={{flex: 0, flexBasis: 'auto', marginVertical: 20}}
          >
            Please Try Again
          </Button>
        </View>
      )}
    </View>
  );
};

export default WPStatus;

const styles = StyleSheet.create({
  wpTitle: {
    ...globalFontStyle.appFontTitle,
    color: Colors.black,
    marginTop: 15,
  },
  wpSubTitle: {
    ...globalFontStyle.appFontBody,
    color: Colors.grey2,
    textAlign: 'center',
    marginTop: 10,
  },
});
